import {
  useTheme
} from "./chunk-JVDTBYWX.js";
import {
  avatarTheme
} from "./chunk-PTC7KVHU.js";

// src/components/avatar.tsx
import * as React from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
function AvatarRoot({ as, src, alt, shape, size, className, ...props }, ref) {
  const Component = as ?? "img";
  const contextTheme = useTheme();
  const theme = contextTheme?.avatar ?? avatarTheme;
  const defaultProps = theme?.defaultProps;
  size ??= defaultProps?.size ?? "md";
  shape ??= defaultProps?.shape ?? "circular";
  const styles = twMerge(theme.baseStyle, theme["size"][size], className);
  return /* @__PURE__ */ jsx(
    Component,
    {
      ...props,
      ref,
      src,
      alt,
      className: styles,
      "data-shape": shape
    }
  );
}
AvatarRoot.displayName = "MaterialTailwind.Avatar";
var Avatar = React.forwardRef(AvatarRoot);
var avatar_default = Avatar;

export {
  Avatar,
  avatar_default
};
